<style scoped>
	.ly-page{
		color:#181a21;
		margin-top: 20px;
	}
	select{
		border:none;
		color: #747474;
		background-color: transparent;
	}
</style>
<template>
	<div class="ly-page row" v-if="total > 1">
		<div class="col-xs-4">
			每页显示
			<select v-model="perpage" @change="change">
				<option value="20">20</option>
				<option value="40">40</option>
				<option value="60">60</option>
				<option value="80">80</option>
			</select>条
		</div>
		<div class="col-xs-8">
			<ul class="pagination m0 pull-right">
		        <li @click="prev">
		        	<a href="javascript:;" title="上一页">
		        		<span>«</span>
		        	</a>
		        </li>
		        <li :class="0 == (page-1) ? 'active' : ''" @click="filter(0)">
		        	<a href="javascript:;">{{1}}</a>
		        </li>
		        <li v-if="start > 0">
		        	<a href="javascript:;"><span>...</span></a>
		        </li>
		        <li v-for="n in total" :class="n == page-1?'active':''" v-if="n>start&&n<end-1" @click="filter(n)">
		        	<a href="javascript:;">{{n+1}}</a>
		        </li>
		        <li v-if="end < total">
		        	<a href="javascript:;"><span>...</span></a>
		        </li>
		        <li :class="total == page ? 'active' : ''" @click="filter(total - 1)">
		        	<a href="javascript:;">{{total}}</a>
		        </li>
		        <li @click="next">
		        	<a href="javascript:;" title="下一页">
		        		<span>»</span>
		        	</a>
		        </li>
		     </ul>
		</div>
	</div>
</template>
<script>
	module.exports = {
		props : ['total'],
		data : function(){
			return {
				page : 1,//当前页
				perpage : 20,
				/**
				* 页数重置
				*/
				resetPage : function(){
					this.page = 1;
				}
			}
		},
		computed : {
			start : function(){
				var v = 0;
				if(this.total > 15){
					v = this.page - 5;
					v = v < 0 ? 0 : v;
				}
				return v;
			},
			end :function(){
				var v =  this.total;
				if(this.total > 15){
					v = this.page + 5;
					v = v > this.total ? this.total : v;
				}
				return v;
			}	
		},
		methods : {
			/**
			* 分页条数的选择
			*/
			change : function(){
				this.page = 1;
				this.$dispatch('paging', this.page,this.perpage);
			},
			/**
			* 上一页
			*/
			prev : function(){
				this.page -= 1;
				this.page = this.page < 1 ? 1 : this.page;
				this.$dispatch('paging', this.page,this.perpage);
			},
			/**
			* 下一页
			*/
			next : function(){
				this.page += 1;
				this.page = this.page > this.total ? this.total : this.page;
				this.$dispatch('paging', this.page,this.perpage);
			},
			/**
			* 根据指定页，筛选
			*/
			filter : function(page){
				this.page = page + 1;
				this.$dispatch('paging', this.page,this.perpage);
			}
		}
	}
</script>


/** WEBPACK FOOTER **
 ** Page.vue?57d12b86
 **/